module.exports = __webpack_public_path__ + "img/tencenttke.0b34fe07.svg";